import type { SVGProps } from "react";
import * as React from "react";

export const DotsVerticalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 8 35"
    className="fill-current"
    {...props}
  >
    <circle
      cx={3.7}
      cy={4.2}
      r={3.7}
      fill="currentColor"
    />
    <circle
      cx={3.7}
      cy={17.6}
      r={3.7}
      fill="currentColor"
    />
    <circle
      cx={3.7}
      cy={31}
      r={3.7}
      fill="currentColor"
    />
  </svg>
);
